import { render } from "./InputComponent.vue?vue&type=template&id=0d76761e&scoped=true"
import script from "./InputComponent.vue?vue&type=script&lang=js"
export * from "./InputComponent.vue?vue&type=script&lang=js"

import "./InputComponent.vue?vue&type=style&index=0&id=0d76761e&scoped=true&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-trainer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d76761e"]])

export default __exports__